export const CONDITION_TYPES = {
  COUNT: 'count',
  SUM: 'sum',
  STREAK: 'streak',
  TIME_RANGE: 'time_range',
  DAILY: 'daily',
  COMPOSITE: 'composite',
  CUSTOM: 'custom',
};